import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcLockerFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17 7A5 5 0 0 0 7 7v2H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-1zm-7.998-.112A3 3 0 0 1 12 4l.113.002A3 3 0 0 1 15 7v2H9V7zm2.323 9.552 3.677-3.677a.75.75 0 0 1 .537-.228.73.73 0 0 1 .548.228.74.74 0 0 1 .232.542.74.74 0 0 1-.232.543l-4.13 4.129a.87.87 0 0 1-.632.27.87.87 0 0 1-.633-.27l-2.028-2.03a.75.75 0 0 1-.228-.537.73.73 0 0 1 .228-.547.74.74 0 0 1 .542-.233q.31 0 .542.233z",
    clipRule: "evenodd"
  }));
}
var IcLockerFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcLockerFill));

export { IcLockerFill as I };
